<template>
  <div
    class="navbar-container"
    :class="{
      'mobile-px-0':
        state.token &&
        ($route.path.includes('dashboard') ||
          $route.path.includes('advancetrade')),
    }"
  >
    <div class="items">
      <a @click.prevent="$router.push('/advancetrade')" href="">
        معامله حرفه ای
      </a>
      <a @click.prevent="$router.push({ name: 'Faq' })" href="">
        راهنمای استفاده
      </a>
      <a @click.prevent="$router.push({ name: 'Fee' })" href=""> کارمزد ها </a>
    </div>
    <div class="avatar">
      <div
        @click="$router.push({ name: 'Notifications' })"
        class="notif-container"
      >
        <inline-svg
          :src="require('../../assets/icons/sidebarNotifs.svg')"
          alt=""
          class="notification"
        />
      </div>
      <div @click="dropToggle = !dropToggle" class="profile">
        <inline-svg
          class="arrowsvg"
          :src="require('../../assets/icons/inputarrow.svg')"
        />
        <span class="name">
          {{ state.userInfo.firstName }} {{ state.userInfo.lastName }}</span
        >

        <img
          class="avatar-img"
          src="../../assets/avatar.svg"
          alt=""
          width="30"
          style="border-radius: 50%"
        />
      </div>
      <transition name="drop">
        <div v-if="dropToggle" class="drop-down">
          <a
            @click.prevent="reD(item.address)"
            v-for="(item, index) in dropItems"
            :key="index"
            href=""
            class="item"
          >
            {{ item.name }}
          </a>
          <a @click.prevent="$logout" href="" class="item"> خروج </a>
        </div>
      </transition>
      <!-- <label class="switch">
        <input @change="changeTheme" type="checkbox" v-model="checked" hidden />
        <span class="slider" />
        <img src="@/assets/Moon.svg" alt="moon" class="moon" />
        <img src="@/assets/Sun.svg" alt="sun" class="sun" />
      </label> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "DashNavbar",
  data() {
    return {
      checked: this.state.theme === "light",
      dropToggle: false,
      dropItems: [
        {
          name: "داشبورد",
          address: "Dashboard",
        },
        {
          name: "کیف پول",
          address: "Wallet",
        },
        {
          name: "حساب کاربری",
          address: "Account",
        },
        {
          name: "دعوت از دوستان",
          address: "InviteFriends",
        },
      ],
    };
  },
  methods: {
    changeTheme() {
      if (this.checked) {
        this.state.theme = "light";
        localStorage.theme = "light";
        document.body.classList.remove("dark");
      } else {
        this.state.theme = "dark";
        localStorage.theme = "dark";
        document.body.classList.add("dark");
      }
    },
    reD(e) {
      this.$router.push({ name: e });
    },
  },
  created: function () {
    window.addEventListener("click", (event) => {
      if (!event.target.closest(".profile")) {
        this.dropToggle = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.mobile-px-0 {
  @media (max-width: 600px) {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
.notification {
  fill: var(--grey);
}
.items {
  display: flex;
  flex-direction: row;
  column-gap: 40px;
}
.navbar-container {
  width: 100%;
  display: flex;
  background: var(--home-background);
  z-index: 105;
  padding: 10px 20px;
  top: 0;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 40px;
  align-items: center;
  a {
    color: var(--dark-grey);
    font-weight: 400;
    font-size: clamp(11px, 1vw, 14px);
  }
}
.avatar {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  column-gap: 40px;
  align-items: center;
  padding-left: 10px;
  .drop-down {
    overflow: hidden;
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    background: var(--light-grey);
    border-radius: 12px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    .item {
      background: var(--light-grey);
      border-radius: 4px;
      padding: 5px;
      width: 100%;
      text-align: center;
    }
  }
  .profile {
    display: flex;
    flex-direction: row;
    column-gap: 5px;
    align-items: center;
    .name {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      @media (max-width: 576px) {
        font-size: 14px;
        max-width: 52px;
      }
    }
  }
  .notif-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    background: var(--light-grey);
    border-radius: 4px;
    width: 36px;
    height: 36px;
  }
}
@media only screen and (max-width: 500px) {
  .navbar-container {
    column-gap: 10px;
  }
  .items {
    column-gap: 10px;
  }
  .avatar {
    column-gap: 4px;
    padding-left: 0;
    .avatar-img {
      display: none;
    }
  }
}
.switch {
  height: 40px;
  width: 85px;
  /*flex-basis: 85px;*/
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  background-color: var(--light-grey);
  position: relative;
  align-items: center;
  margin: 0;
  border-radius: 5px;
  margin-right: 8px;
  direction: ltr;
  @media (max-width: 600px) {
    height: 30px;
    width: 61px;
    margin-right: 4px;
  }

  .sun {
    z-index: 99;
    right: 0;
    width: 50%;
    height: 20px;
    cursor: pointer;
    @media (max-width: 600px) {
      height: 12px;
    }
  }

  .moon {
    z-index: 99;
    left: 0;
    width: 50%;
    height: 20px;
    cursor: pointer;
    @media (max-width: 600px) {
      height: 12px;
    }
  }
  input {
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 25%;
    background-color: var(--dark-primary);
    width: calc(50% - 10px);
    height: calc(100% - 10px);
    border-radius: 5px;
    transition: 0.4s;
  }

  input:checked + .slider {
    box-shadow: none;
    left: 75%;
  }
}
</style>
